var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":_vm.labelFor}},[_vm._v(" "+_vm._s(_vm.labelContent)+" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({ content: _vm.tooltipMess}),expression:"{ content: tooltipMess}",modifiers:{"top":true}}]},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }